import { Button, CircularProgress } from "@mui/material";
import { ReactNode } from "react";

interface IProps {
  text: string | ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export const FormActionButton = (props: IProps) => {
  return (
    <Button
      type="submit"
      fullWidth
      variant="contained"
      disabled={props.disabled || props.loading}
      sx={{
        mt: 1,
        mb: 0,
        color: "white",
        borderRadius: 50,
        bgcolor: "primary.main",
        lineHeight: "unset",
      }}
      onClick={props.onClick}
      startIcon={props.loading ? <CircularProgress size={20} color="inherit" /> : undefined}
    >
      {props.text}
    </Button>
  );
};
